export class Processor {
  channel = '';
  comApp?: string[];
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/processor.model.ts